import { Fragment, useState, useEffect, lazy, Suspense } from "react";
import { ProductComponent } from "../../components/productComponent";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { getRecommendedHome, getOfertasHome,images_products_route } from "../../api/productApi";
import { getGallery } from "../../api/galleryApi";
import { getImages } from "../../api/imageApi";
import { useApi } from "../../context/apiContext";
import { useCart } from '../../context/cartContext';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Picture from "../../components/Picture";
import LazyOnScroll from "../../components/LazyOnScroll";
import "../../scss/home.scss";
import "../../scss/footer.scss";
import { useAuth } from './../../authContext';
import product from "../../classes/product";
import { sellyApi } from "../../api";

const BtnWhatsapp = lazy(() => import("../../components/BtnWhatsapp"));
const ModalLogUserComponent = lazy(() => import("../../components/ModalLogUserComponent"));


export default function HomePage() {
    const [products, setProducts] = useState([]);
    const [ofertas, setOferts] = useState([]);
    const [bannerMainHome, setBannerMainHome] = useState([]);
    const [collecion, setCollecion] = useState([]);
    const [gallery, setGallery] = useState([]);
    const navigate = useNavigate();

    const { getTextByKey,getTextByKeyLink, getTextBigByKey, extractNameFromLocate, currentFav, getPropiertyByLocale } = useApi();
    const { currentUser } = useAuth();


    // const [ctaVsitShop] = useState

    const [bgVisitarTienda, setBgVisitarTienda] = useState([]);

    const { tiendaGeneral} = useCart();
    const [galleryChooseYourFavoriteCombo, setGalleryChooseYourFavoriteCombo] = useState([]);
    const [galleryUnmissablePromotionMobile, setGalleryUnmissablePromotionMobile] = useState([]);
    const [galleryUnmissablePromotionDesk, setGalleryUnmissablePromotionDesk] = useState([]);
    const [galleryCervalleKitchen, setGalleryCervalleKitchen] = useState([]);
    const [ bannerHome, setBannerHome ] = useState([]);
		const [ bannerVisitar, setBannerVisitar ] = useState([]);
		const [ bannerVisitarMobile, setBannerVisitarMobile ] = useState([]);
		const [ clockImg, setClockImg ] = useState([]);
		const [ deliveryImg, setDeliveryImg ] = useState([]);
    const [showModal, setShowModal] = useState(false);
     const [mostrarProducto, setMostrarProducto] = useState(false);
    const [heroAutoplay, setHeroAutoplay] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => setHeroAutoplay(true), 5000);
        return () => clearTimeout(t);
    }, []);

       
    
        useEffect(() => {
        getGallery("banner_main_home").then(setBannerMainHome);

        Promise.all([
            getImages("bg-visitar-tienda"),
            getImages("clock"),
            getImages("delivery"),
            getGallery("elige-tu-combo-favorito"),
            getGallery("promocion-imperdible-mobile"),
            getGallery("promocion-imperdible-desk"),
            getGallery("cocina-cervalle"),
            getImages("banner-home"),
            getImages("banner-visita-tienda"),
            getImages("banner-visita-tienda-mobile"),
            getSeccionProductos(),
            getMostrarModalSuscripcion(),
        ]).then(([bg, clock, delivery, chooseCombo, promoMobile, promoDesk, cervalle, bannerHomeImg, bannerVisita, bannerVisitaMobile, mostrarProductos, mostrarModalSuscripcion]) => {
            setBgVisitarTienda(bg);
            setClockImg(clock);
            setDeliveryImg(delivery);
            setGalleryChooseYourFavoriteCombo(chooseCombo);
            setGalleryUnmissablePromotionMobile(promoMobile);
            setGalleryUnmissablePromotionDesk(promoDesk);
            setGalleryCervalleKitchen(cervalle);
            setBannerHome(bannerHomeImg);
            setBannerVisitar(bannerVisita);
            setBannerVisitarMobile(bannerVisitaMobile);
            setMostrarProducto(mostrarProductos);
            const dismissed = localStorage.getItem('modal-suscripcion');
            setShowModal(isSettingEnabled(mostrarModalSuscripcion) && !dismissed);
        });
    }, []);

    const isSettingEnabled = (value) => {
        return value === true || value === 1 || value === '1' || value === 'true';
    };

    const getSeccionProductos = async () => {
    try {
        const { data } = await sellyApi.get(`/store/get-setting?llave=mostrar-todos-productos-home&formato=JSON`);
        return data 
    } catch (error) {
        console.error("Error al obtener configuración de productos:", error);
        return false;
    }
    };

    const getMostrarModalSuscripcion = async () => {
        try {
            const { data } = await sellyApi.get(`/store/get-setting?llave=mostrar-modal-suscripcion&formato=JSON`);
            return data;
        } catch (error) {
            console.error("Error al obtener configuración del modal de suscripción:", error);
            return true;
        }
    };

    useEffect(() => {
        setProducts([]);
        setOferts([]);
        const fetchData = async () => {
        const recomendados=await getRecommendedHome(tiendaGeneral);
         setProducts(recomendados);
        const ofertas=await getOfertasHome(tiendaGeneral);
        setOferts(ofertas);
        
        }
         fetchData();
    },[tiendaGeneral]);

    const gotoTop = event => {
        hideCart();
        window.scrollTo(0, 0);
    };

    return (
        <Fragment>
            {/* se oculta por peticion del cliente */}
            {/* <div className='p-2 px-4 note-publi'>
                <Link to='/news-letter'>{getTextByKey("news-letter")}</Link>
            </div> */}
            <Suspense fallback={null}>
                <BtnWhatsapp />
                <ModalLogUserComponent showModal={showModal} setShowModal={setShowModal} />
            </Suspense>
					 { bannerHome?.length > 0 &&

            <Swiper modules={[Autoplay, Pagination]}
                            pagination={{ clickable: true }}
                            autoplay={{ delay: 6000, disableOnInteraction: true }}
                            autoHeight={true}
                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 0,
                                },
                            }}>
                            {bannerMainHome && bannerMainHome.map((banner, index) => (
                                <SwiperSlide key={index} className="px-md-4 px-xl-0">
                                    <div className="video-banner">
                                        <Picture
                                            src={banner.image}
                                            alt={'Banner'}
                                            classImg={'w-100'}
                                            width={1360}
                                            height={430}
                                            loading={index === 0 ? 'eager' : 'lazy'}
                                            fetchPriority={index === 0 ? 'high' : undefined}
                                        />
                                        {banner.link && (
                                            <div className="video-banner-link text-center py-3 py-md-0">
                                                <a href={banner.link} target={banner.link.startsWith("https:") ? "_blank" : "_self"} className="btn-g py-2 px-1 px-xl-5">{getPropiertyByLocale(banner.names, "titulo")}</a>
                                            </div>
                                        )}
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
            }
						 
            <div className="section-features-service py-4">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-6 col-lg-5 col-xl-4 offset-md-2 offset-lg-0 mb-3 mb-lg-0">
                            <OverlayTrigger overlay={<Tooltip className="bg-transparent d-md-none"> <div dangerouslySetInnerHTML={{ __html: getTextBigByKey("horario_desc_mobile") }}  /> </Tooltip>}>
                                <span className="d-inline-block">
                                    <div className="d-md-flex text-center text-md-start">
                                        <div className="me-md-3">
                                            { clockImg && clockImg.length > 0 ?
                                                <Picture src={clockImg[0].image} alt={'Clock fast icon'} classImg={'icon-singular-feature'} width={80} height={80} /> : ''
                                            }		
                                        </div>
                                        <div>
                                            <p className="gray-1-color source-sans-bold mb-0">{getTextByKey('horarios')}</p>
                                            <div className="mb-0 descripcion-features d-none d-md-block" dangerouslySetInnerHTML={{ __html: getTextBigByKey("horarios_desc") }}></div>
                                        </div>
                                    </div>
                                </span>
                            </OverlayTrigger>
                        </div>
                        <div className="col-6 col-lg-5 col-xl-4 offset-md-2 offset-lg-0">
                        <OverlayTrigger overlay={<Tooltip className="bg-transparent d-md-none">
                        <div dangerouslySetInnerHTML={{ __html: getTextBigByKey("tiempos_desc_mobile") }}  />
                        </Tooltip>}>
                                <span className="d-inline-block">
                                    <div className="d-md-flex text-center text-md-start">
                                        <div className="me-md-3">
                                            { deliveryImg && deliveryImg.length > 0 ?
                                                <Picture src={deliveryImg[0].image} alt={'Delivery fast icon'} classImg={'icon-singular-feature'} width={80} height={80} /> : ''
                                            }
                                        </div>
                                        <div>
                                            <p className="gray-1-color source-sans-bold mb-0">{getTextByKey('tiempo_entrega')}</p>
                                            <div className="mb-0 descripcion-features d-none d-md-block" dangerouslySetInnerHTML={{ __html: getTextBigByKey("tiempos_desc") }}></div>
                                        </div>
                                    </div>
                                </span>
                            </OverlayTrigger>
                        </div>
                    </div>
                </div>
            </div>
            <div className="desk">
                { bannerVisitar.length > 0 && 
                    <div className="cta-visit-shop bg-options-repeat" style={{ backgroundImage: `url(${images_products_route + bannerVisitar[0].image})` }}>
                        <div className="cta-visit-shop-link">
                                <Link to={bannerVisitar?.[0]?.link} onClick={gotoTop} className="btn-g py-2 px-4 px-xl-5 text-nowrap">{getTextByKey('visitar-tienda')}</Link>
                        </div>
                    </div>
                }
            </div>
            <div className="mobile">
                { bannerVisitarMobile.length > 0 && 
                    <div className="cta-visit-shop bg-options-repeat" style={{ backgroundImage: `url(${images_products_route + bannerVisitarMobile[0].image})` }}>
                        <div className="cta-visit-shop-link">
                                <Link to={bannerVisitarMobile?.[0]?.link} onClick={gotoTop} className="btn-g py-2 px-4 px-xl-5 text-nowrap">{getTextByKey('visitar-tienda')}</Link>
                        </div>
                    </div>
                }
            </div>
            <div className="gray-1-color section-offers my-5">
                <div className="container">
                    <h2 className="primary-color text-center fw-bold mb-4">{getTextByKey('ofertas')}</h2>
                    <div className="position-relative">
                        <Swiper modules={[Navigation, Autoplay]}
                                navigation
                                autoplay={{ delay: 6000, disableOnInteraction: true }}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 0,
                                    },
                                    576: {
                                        slidesPerView: 2,
                                        spaceBetween: 0,
                                    },
                                    992: {
                                        slidesPerView: 3,
                                        spaceBetween: 0,
                                    },
                                    1200: {
                                        slidesPerView: 4,
                                        spaceBetween: 0,
                                    },
                                }}>
                            {ofertas && ofertas.map((product, index) => (
                                <SwiperSlide key={index} className="px-4 px-xl-0">
                                    <ProductComponent key={index} product={product} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
            <section className="pink-1-bg-color white-color py-5 section-skew section-our-recommended">
                <div className="container">
                    <h2 className="text-center fw-bold mb-4">{getTextByKey('recomendados')}</h2>
                    <div className="position-relative">
                        <Swiper modules={[Navigation, Autoplay]}
                                navigation
                                autoplay={{ delay: 6000, disableOnInteraction: true }}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 0,
                                    },
                                    576: {
                                        slidesPerView: 2,
                                        spaceBetween: 0,
                                    },
                                    992: {
                                        slidesPerView: 3,
                                        spaceBetween: 0,
                                    },
                                    1200: {
                                        slidesPerView: 4,
                                        spaceBetween: 0,
                                    },
                                }}>
                            {products ? products.map((product, index) => (
                                <SwiperSlide key={index} className="px-4 px-xl-0">
                                    <ProductComponent key={index} product={product} />
                                </SwiperSlide>
                            )): ''}
                        </Swiper>
                    </div>
                </div>
            </section>
            {galleryChooseYourFavoriteCombo.length > 0 &&
                <LazyOnScroll minHeight={400}>
                <div className="cta-choose-your-favorite-combo my-5">
                    <div className="container-fluid px-xl-4">
                        <h2 className="text-center primary-color fw-bold mb-4">{getTextByKey('elige_combo')}</h2>
                        <div className="row">
                        {galleryChooseYourFavoriteCombo.map((combo, index) => (
                            <div className="col-12 col-md-6 px-2 mb-2" key={index}>
                                <div className="singular-choose-your-favorite-combo">
									<Picture src={combo.image} alt={"bg-choose-your-favorite-combo"} classImg={"w-100 bg-singular-choose-your-favorite-combo"} width={700} height={300} />
                                    <div className="cta-choose-your-favorite-combo-link py-3 py-md-0">
                                      <a href={combo.link} className="btn-g py-2 px-4 px-xl-5">{getPropiertyByLocale(combo.names, 'titulo')}</a>
                                    </div>
                                </div>
                            </div>
                        ))}
                        </div>
                    </div>
                </div>
                </LazyOnScroll>
            }
            {(galleryUnmissablePromotionMobile.length > 0 && mostrarProducto) &&
                <LazyOnScroll minHeight={300}>
                <div className="cta-unmissable-promo my-5 d-lg-none">
                    <div className="container-fluid gx-0">
                        <h2 className="text-center primary-color mb-4 fw-bold">{getTextByKey('promo_imperdible')}</h2>
                        <div className="row gx-0">
                            <div className="col-12">
                                <Swiper modules={[Navigation, Pagination, Autoplay]}
                                        /* pagination={{ clickable: true }} */
                                        autoplay={{ delay: 4000, disableOnInteraction: false }}
                                        slidesPerView={1}
                                        >
                                    {galleryUnmissablePromotionMobile.map((promotion, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="singular-choose-your-favorite-combo">
												<Picture src={promotion.image} alt={'bg-choose-your-favorite-combo'} classImg={'w-100 bg-singular-choose-your-favorite-combo'} width={1200} height={500} />
                                                <div className="cta-choose-your-favorite-combo-link py-3 py-md-0">
                                                    <Link to={promotion.link} className="btn-g py-2 px-4 px-xl-5">{getPropiertyByLocale(promotion.names, 'titulo')}</Link>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
                </LazyOnScroll>
            }
            {(galleryUnmissablePromotionDesk.length > 0 && mostrarProducto) &&
                <LazyOnScroll minHeight={400}>
                <div className="cta-unmissable-promo my-5 d-none d-lg-block">
                    <div className="container-fluid gx-0">
                        <h2 className="text-center primary-color mb-4 fw-bold">{getTextByKey('promo_imperdible')}</h2>
                        <div className="row gx-0">
                            <div className="col-12">
                                <Swiper modules={[Navigation, Autoplay]}
                                        /* pagination={{ clickable: true }} */
                                        autoplay={{ delay: 4000, disableOnInteraction: false }}
                                        slidesPerView={1}
                                        >
                                    {galleryUnmissablePromotionDesk.map((promotion, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="singular-choose-your-favorite-combo">
																							 <Picture src={promotion.image} alt={'bg-choose-your-favorite-combo'} classImg={"w-100 bg-singular-choose-your-favorite-combo"} width={1200} height={500} />
                                                <div className="cta-choose-your-favorite-combo-link py-3 py-md-0">
                                                    <Link  to={promotion.link} className="btn-g py-2 px-4 px-xl-5">{getPropiertyByLocale(promotion.names, 'titulo')}</Link>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
                </LazyOnScroll>
            }
            <LazyOnScroll minHeight={500}>
            <div className="quinary-bg-color white-color my-5 py-5 section-skew section-cook-with-us">
                <div className="container-fluid">
                    <div className="p-md-5 p-3">
                        <div className="row justify-content-between">
                            <div className="col-12 col-lg-5 col-xl-3 mb-4">
                                <div className="text-center text-lg-start">
                                    <h1 className="tertiary-color carrefour-sans-bold mb-4">{getTextByKey('cocina_con_cervalle')}</h1>
                                    <div className="big-text" dangerouslySetInnerHTML={{ __html: getTextBigByKey("texto-cocina-cervalle-home") }}></div>
                                    <div className="mt-4">
                                        <Link to={getTextByKeyLink('todas_recetas')} className="btn-g py-2 px-4 px-xl-5">{getTextByKey('todas_recetas')}</Link>
                                    </div>
                                </div>
                            </div>
                                <div className="col-12 col-lg-6 col-xl-7 px-0 pe-xl-5 mb-4">
                                    {galleryCervalleKitchen.length > 0 && 
                                        <div className="row">
                                            {galleryCervalleKitchen.map((product, index) => (
                                                <div className="col-6 text-center mb-4" key={index}>
                                                    <div className="singular-product product-hover p-0">
                                                        <div className="image-product">
                                                        <Picture src={product.image} alt={"Product item"} classImg={"w-100 image"} width={400} height={400} />
                                                        </div>
                                                        <div className="mt-3">
                                                            <h3 className="mb-0 product-name">{getPropiertyByLocale(product.names, "titulo")}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            </LazyOnScroll>
        </Fragment>
    );
}
